import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter
} from "@heroui/react";
import { CheckCircleIcon } from '@heroicons/react/outline';

interface ChecklistCardProps {
  title: string;
  items: string[];
  className?: string;
  footerIcon?: React.ReactNode;
  footerText?: string;
}

/**
 * ChecklistCard - A reusable component for displaying checklist items in a card
 */
export default function ChecklistCard({
  title,
  items,
  className = "",
  footerIcon,
  footerText
}: ChecklistCardProps) {
  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>
      <CardHeader className="pb-0 px-6">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </CardHeader>
      <CardBody className="p-6">
        <ul className="space-y-4">
          {items.map((item, index) => (
            <li key={index} className="flex">
              <CheckCircleIcon className="h-6 w-6 flex-shrink-0 text-green-500" />
              <span className="ml-3 text-gray-700">{item}</span>
            </li>
          ))}
        </ul>
      </CardBody>
      
      {(footerIcon || footerText) && (
        <CardFooter className="px-6 py-4 bg-gray-50">
          <div className="flex items-center">
            {footerIcon && <div className="mr-2">{footerIcon}</div>}
            {footerText && <span className="text-sm text-gray-600">{footerText}</span>}
          </div>
        </CardFooter>
      )}
    </Card>
  );
}